import React from 'react';
import Select from 'components/Core/Select';
import { staffCountOptions } from 'components/Form/utils/generalFormData';

const OfficeCountSelect = (props) => <Select {...props} options={staffCountOptions} />;

export default OfficeCountSelect;
